export const INTEGRATION_MESSAGING = {
  "hubspot-two-way-integration": {
    integrationAvailable: "The Hubspot Two-way integration is now available.",
    integrationInProgress:
      "To configure the Hubspot integration, please follow the steps in the popup. If you're blocking popups, try disabling popups for this site and try again."
  }
};
